import { createStyles } from '@byecode/ui/theme/createStyles'
import { css } from '@byecode/ui/theme/stitches.config'

export const useStyles = createStyles(() => ({
    root: css({
        position: 'relative'
    }),
    loading: css({
        position: 'absolute',
        zIndex: 1,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
    }),
    pagination: css({
        marginTop: 12
    })
}))
